import type { Journey } from "../../types/journey";

export const IUI_JOURNEY_ES: Journey = {
	id: "iui",
	type: "iui",
	name: "Recorrido IIU",
	treatmentType: "Tratamiento IIU",
	totalSteps: 7,
	steps: [
		{
			id: "iui-step-1-initial-consultation-assessment",
			order: 1,
			title: "Consulta inicial y evaluación",
			description:
				"Este paso establece tu punto de partida y te introduce al camino de la IIU. Trae tu historial médico, conoce a tu especialista y sal con un plan personalizado.",
			estimatedDateRange: "[Pre-ciclo] Est. Semana 1 – Semana 2",
			status: "completed",
			subSteps: [
				{
					id: "iui-step-1-initial-consultation-assessment-ss-01",
					title: "Preparar documentación e historial",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss-02",
					title: "Reservar y asistir a la consulta",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss-03",
					title: "Revisar resultados y próximos pasos",
				},
			],
			highlight: {
				dayCount: "7–14 días",
				monitoringSchedule:
					"Prepara tu historial médico antes de la cita; Revisa el plan de tratamiento dentro de 24 horas tras la consulta",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Una primera consulta de fertilidad cubre mucho terreno. Anotar tus preguntas con antelación ayuda a muchas personas a sentirse más preparadas y seguras.",
				milestone: "Plan de tratamiento recibido, est. Semana 2",
				currentDayLabel: "Día [N] de ~14",
				estimatedLengthDays: 14,
				monitoringFrequency: "1 visita",
				nextEvent: "completado",
			},
			tasks: [
				{
					id: "iui-step-1-initial-consultation-assessment-ss1-task1",
					title: "Completar: Formulario de admisión",
					description: "Datos personales para tu archivo clínico",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-01",
					subStepTitle: "Preparar documentación e historial",
					progressTotal: 8,
					progressUnit: "campos",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss1-task2",
					title: "Completar: Cuestionario de salud",
					description: "Información de historial médico para tu próxima visita",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-01",
					subStepTitle: "Preparar documentación e historial",
					progressTotal: 12,
					progressUnit: "campos",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss1-task3",
					title: "Subir: Historial médico previo",
					description: "Historial de tratamientos previos y hallazgos",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-01",
					subStepTitle: "Preparar documentación e historial",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss1-task4",
					title: "Subir: Carta de derivación",
					description: "Carta de tu médico de cabecera o derivante",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-01",
					subStepTitle: "Preparar documentación e historial",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss1-task5",
					title: "Subir: Documentos de identidad",
					description: "Pasaporte o identificación oficial con foto",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-01",
					subStepTitle: "Preparar documentación e historial",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss2-task1",
					title: "Reservar: Consulta inicial con especialista",
					description: "Primera cita con tu especialista en fertilidad",
					category: "clinical",
					deadline: "Lo antes posible",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-02",
					subStepTitle: "Reservar y asistir a la consulta",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss2-task2",
					title: "Completar: Evaluación pre-tratamiento",
					description: "Datos de salud y estilo de vida para tu equipo",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-02",
					subStepTitle: "Reservar y asistir a la consulta",
					progressTotal: 6,
					progressUnit: "campos",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss3-task1",
					title: "Revisar y firmar: Resumen del plan de tratamiento",
					description: "Tu plan personalizado de IIU para revisar",
					category: "clinical",
					deadline: "Dentro de 24 horas tras la consulta",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-03",
					subStepTitle: "Revisar resultados y próximos pasos",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss3-task2",
					title: "Completar: Datos de facturación",
					description: "Información de seguro y pago para tu archivo",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-03",
					subStepTitle: "Revisar resultados y próximos pasos",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-ss3-task3",
					title: "Subir: Autorización del seguro",
					description: "Carta de pre-aprobación de tu proveedor de seguro",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-1-initial-consultation-assessment-ss-03",
					subStepTitle: "Revisar resultados y próximos pasos",
				},
			],
			faqs: [
				{
					id: "iui-step-1-initial-consultation-assessment-faq-1",
					question: "¿En qué se diferencia la IIU del FIV?",
					answer:
						"La IIU — Inseminación Intrauterina — coloca esperma preparado directamente en el útero en el momento de la ovulación, trabajando con un ciclo natural o ligeramente estimulado. La FIV implica recuperar óvulos de los ovarios y fertilizarlos en el laboratorio. La IIU es menos invasiva, menos costosa y requiere menos medicamentos, pero generalmente tiene una tasa de éxito menor por ciclo. Tu especialista discutirá cuál es más adecuada según tu situación específica.",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-faq-2",
					question: "¿A quién es más probable que ayude la IIU?",
					answer:
						"La IIU suele ser más efectiva para personas con infertilidad inexplicada, problemas leves de factor masculino, factores cervicales o quienes usan esperma de donante. A menudo se recomienda como tratamiento de primera línea antes de pasar a FIV. Las tasas de éxito varían según la edad, la causa de infertilidad y si el ciclo es natural o medicado. Tu especialista te dará una visión realista de los resultados esperados según tu perfil individual.",
				},
				{
					id: "iui-step-1-initial-consultation-assessment-faq-3",
					question: "¿Cuántos ciclos de IIU se recomiendan habitualmente?",
					answer:
						"La mayoría de las clínicas sugieren intentar 3–6 ciclos antes de reevaluar o considerar FIV, aunque esto varía según la edad y las circunstancias individuales. Cada ciclo proporciona información — si varios ciclos no resultan en embarazo, el equipo revisará si el enfoque o el diagnóstico necesitan actualizarse. La decisión de continuar es clínica y personal, y tu especialista te guiará en esa conversación.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Consulta inicial y evaluación.",
		},
		{
			id: "iui-step-2-fertility-testing",
			order: 2,
			title: "Pruebas de fertilidad",
			description:
				"Este paso construye una línea base de fertilidad mediante análisis de sangre, ecografías y evaluaciones uterinas y de esperma — dándole al equipo lo necesario para diseñar el protocolo IIU adecuado.",
			estimatedDateRange:
				"Est. 1 abr – 14 abr 2026 [Pre-ciclo, DC2–DC3 para ecografía basal]",
			estimatedStartDate: "2026-04-01",
			status: "completed",
			subSteps: [
				{
					id: "iui-step-2-fertility-testing-ss-01",
					title: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss-02",
					title: "Evaluación uterina (si está indicada)",
				},
				{
					id: "iui-step-2-fertility-testing-ss-03",
					title: "Pruebas de pareja / esperma (si aplica)",
				},
			],
			highlight: {
				dayCount: "7–14 días",
				monitoringSchedule:
					"Asiste a la ecografía basal en el DC2 o DC3; Notifica a la clínica inmediatamente cuando empiece tu período (Día 1)",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Esperar resultados puede generar incertidumbre. La mayoría llegan en pocos días, y cada resultado — sea cual sea — ayuda al equipo a construir un mejor plan.",
				milestone: "Todos los resultados disponibles, est. 14 abr",
				currentDayLabel: "Día [N] de ~14",
				estimatedLengthDays: 14,
				monitoringFrequency: "2–3 visitas",
				nextEvent: "completado",
			},
			tasks: [
				{
					id: "iui-step-2-fertility-testing-ss1-task1",
					title: "Reservar: Análisis de sangre AMH",
					description: "Mide tu reserva ovárica antes del tratamiento",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-2-fertility-testing-ss-01",
					subStepTitle: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss1-task2",
					title: "Análisis: Análisis de sangre AMH",
					description: "Análisis de reserva ovárica para tu protocolo",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-2-fertility-testing-ss-01",
					subStepTitle: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss1-task3",
					title: "Subir: Resultados de AMH",
					description: "Resultados del análisis de reserva ovárica",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-2-fertility-testing-ss-01",
					subStepTitle: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss1-task4",
					title: "Notificar: Período comenzó — Día 1",
					description:
						"Registra el día 1 del ciclo para programar tu ecografía basal",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "iui-step-2-fertility-testing-ss-01",
					subStepTitle: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss1-task5",
					title: "Reservar: Ecografía basal",
					description: "Ecografía y panel hormonal de día 2–3",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-2-fertility-testing-ss-01",
					subStepTitle: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss1-task6",
					title: "Análisis: Panel hormonal — E2, FSH, LH y RFA",
					description: "Hormonas basales y recuento de folículos antrales",
					category: "clinical",
					deadline: "Día 2 o 3 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-2-fertility-testing-ss-01",
					subStepTitle: "Reserva ovárica y pruebas hormonales",
				},
				{
					id: "iui-step-2-fertility-testing-ss2-task1",
					title: "Reservar: Evaluación uterina",
					description: "Evalúa la cavidad uterina antes del ciclo IIU",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-2-fertility-testing-ss-02",
					subStepTitle: "Evaluación uterina (si está indicada)",
				},
				{
					id: "iui-step-2-fertility-testing-ss2-task2",
					title: "Análisis: Evaluación uterina",
					description: "Histerosonografía o histeroscopia",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-2-fertility-testing-ss-02",
					subStepTitle: "Evaluación uterina (si está indicada)",
				},
				{
					id: "iui-step-2-fertility-testing-ss3-task1",
					title: "Reservar: Seminograma",
					description:
						"Análisis de esperma de la pareja — coordina con tu clínica",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-2-fertility-testing-ss-03",
					subStepTitle: "Pruebas de pareja / esperma (si aplica)",
				},
				{
					id: "iui-step-2-fertility-testing-ss3-task2",
					title: "Análisis: Seminograma",
					description: "Conteo, motilidad y morfología del esperma",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-2-fertility-testing-ss-03",
					subStepTitle: "Pruebas de pareja / esperma (si aplica)",
				},
				{
					id: "iui-step-2-fertility-testing-ss3-task3",
					title: "Subir: Informe del seminograma",
					description: "Resultados del laboratorio para tu archivo compartido",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-2-fertility-testing-ss-03",
					subStepTitle: "Pruebas de pareja / esperma (si aplica)",
				},
			],
			faqs: [
				{
					id: "iui-step-2-fertility-testing-faq-1",
					question: "¿Qué pruebas se necesitan antes de comenzar la IIU?",
					answer:
						"El estudio estándar previo a la IIU típicamente incluye un análisis de AMH y un recuento de folículos antrales para evaluar la reserva ovárica, un panel hormonal de día 2 o 3, y una evaluación uterina para confirmar que la cavidad es adecuada. Si hay pareja involucrada, también se requiere un seminograma. Algunas clínicas también recomiendan pruebas genéticas. Las pruebas específicas dependerán de tu historia y de lo que el especialista quiera descartar.",
				},
				{
					id: "iui-step-2-fertility-testing-faq-2",
					question: "¿Duele la evaluación uterina?",
					answer:
						"Una histerosonografía implica pasar una pequeña cantidad de solución salina al útero mientras se realiza una ecografía. Suele causar molestias leves similares a cólicos menstruales, que se resuelven rápidamente. Una histeroscopia, si fuera necesaria, es más completa pero generalmente se realiza de forma ambulatoria. Tomar analgésicos sin receta antes, según indique la clínica, suele ayudar. La incomodidad es breve y la información que aporta es realmente importante para planificar.",
				},
				{
					id: "iui-step-2-fertility-testing-faq-3",
					question:
						"¿Y si los resultados del seminograma muestran un problema?",
					answer:
						"Un seminograma con conteo, motilidad o morfología más bajos de lo esperado no descarta automáticamente la IIU — ayuda a determinar qué vía de tratamiento es más adecuada. Las preocupaciones leves de factor masculino a menudo siguen siendo tratables con IIU usando esperma lavado y concentrado. Hallazgos más significativos pueden llevar al equipo a recomendar FIV con ICSI. El especialista revisará todos los resultados juntos antes de hacer una recomendación de protocolo.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Pruebas de fertilidad.",
		},
		{
			id: "iui-step-3-pre-treatment-optimization",
			order: 3,
			title: "Optimización pre-tratamiento",
			description:
				"Antes de que comience el ciclo, este paso cubre los consentimientos, la configuración financiera y la decisión entre un ciclo IIU natural o medicado — para que todo esté listo antes del Día 1.",
			estimatedDateRange:
				"Est. 14 abr – 20 abr 2026 [Pre-ciclo, antes del DC1]",
			estimatedStartDate: "2026-04-14",
			status: "completed",
			subSteps: [
				{
					id: "iui-step-3-pre-treatment-optimization-ss-01",
					title: "Configuración financiera y de seguro",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss-02",
					title: "Documentación de consentimiento",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss-03",
					title: "Tipo de ciclo y configuración del protocolo",
				},
			],
			highlight: {
				dayCount: "5–7 días",
				monitoringSchedule:
					"Firma todos los formularios de consentimiento antes del día 1 del ciclo; Confirma con el especialista si el ciclo es natural o medicado",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Elegir entre un ciclo natural y uno medicado vale la pena discutirlo cuidadosamente con tu especialista. Ambos son válidos — la elección correcta depende de la reserva ovárica, el historial del ciclo y las preferencias personales.",
				milestone: "Protocolo firmado, est. 20 abr",
				currentDayLabel: "Día [N] de ~7",
				estimatedLengthDays: 7,
				monitoringFrequency: "1 visita",
				nextEvent: "completado",
			},
			tasks: [
				{
					id: "iui-step-3-pre-treatment-optimization-ss1-task1",
					title: "Completar: Formulario de verificación de seguro",
					description: "Confirma tu cobertura de IIU con tu proveedor",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
					progressTotal: 4,
					progressUnit: "campos",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss1-task2",
					title: "Reservar: Llamada con agente del seguro",
					description: "Discute tu cobertura para tratamiento IIU",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss1-task3",
					title: "Revisar y firmar: Acuerdo financiero",
					description: "Desglose de costos y términos de pago",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss2-task1",
					title: "Revisar y firmar: Consentimiento general",
					description: "Términos y permisos estándar de la clínica",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-02",
					subStepTitle: "Documentación de consentimiento",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss2-task2",
					title: "Revisar y firmar: Consentimiento informado para IIU",
					description:
						"Riesgos, beneficios y alternativas del procedimiento IIU",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-02",
					subStepTitle: "Documentación de consentimiento",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss3-task1",
					title: "Revisar y firmar: Protocolo de tratamiento",
					description: "Plan de ciclo natural vs medicado",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-03",
					subStepTitle: "Tipo de ciclo y configuración del protocolo",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss3-task2",
					title: "Revisar y firmar: Consentimiento de medicación",
					description: "Reconoce los riesgos y plan de dosificación",
					category: "medication",
					deadline: "Antes de comenzar la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-03",
					subStepTitle: "Tipo de ciclo y configuración del protocolo",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-ss3-task3",
					title: "Reservar: Reunión con coordinadora",
					description: "Confirma el plan y próximos pasos antes del ciclo",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-3-pre-treatment-optimization-ss-03",
					subStepTitle: "Tipo de ciclo y configuración del protocolo",
				},
			],
			faqs: [
				{
					id: "iui-step-3-pre-treatment-optimization-faq-1",
					question: "¿Cuál es la diferencia entre IIU natural y medicada?",
					answer:
						"Un ciclo IIU natural rastrea la ovulación sin medicación e insemina en el momento del pico natural de LH. Un ciclo medicado utiliza dosis bajas de medicamentos orales o inyectables para estimular uno o dos folículos y luego programa la inyección desencadenante para controlar la ovulación con precisión. Los ciclos medicados generalmente tienen tasas de éxito ligeramente mayores pero también un pequeño riesgo de embarazo múltiple. Tu especialista recomendará según tu edad, diagnóstico y reserva ovárica.",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-faq-2",
					question:
						"¿Qué cubren los formularios de consentimiento para la IIU?",
					answer:
						"El consentimiento de IIU cubre el procedimiento en sí — incluyendo riesgos como cólicos leves, manchado y un pequeño riesgo de infección — así como el uso de esperma de donante si aplica y los medicamentos del ciclo. Si hay un donante conocido, también se requiere un consentimiento legal por separado. Como con cualquier consentimiento médico, se recomienda leer cuidadosamente y hacer preguntas antes de firmar, en lugar de hacerlo por trámite.",
				},
				{
					id: "iui-step-3-pre-treatment-optimization-faq-3",
					question: "¿Se necesita capacitación para las inyecciones en la IIU?",
					answer:
						"Si el protocolo incluye gonadotropinas inyectables, se recomienda capacitación. Para ciclos con medicación oral o naturales, no se necesita capacitación. La enfermera aclarará en la cita de revisión del protocolo qué medicamentos, si los hay, te administrarás tú misma y proporcionará la capacitación si es necesaria.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Optimización pre-tratamiento.",
		},
		{
			id: "iui-step-4-cycle-monitoring-ovulation-tracking",
			order: 4,
			title: "Monitoreo del ciclo y ovulación",
			description:
				"Este paso rastrea el desarrollo folicular y programa la inseminación con precisión a la ovulación — ya sea monitoreando el pico natural de LH o desencadenando la ovulación con una inyección.",
			estimatedDateRange: "Est. 21 abr – 2 may 2026 [DC1–DC14]",
			estimatedStartDate: "2026-04-21",
			status: "completed",
			subSteps: [
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-01",
					title: "Inicio del ciclo y línea base",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-02",
					title: "Seguimiento de la ovulación",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-03",
					title: "Inyección desencadenante (si es medicado)",
				},
			],
			highlight: {
				dayCount: "10–14 días",
				monitoringSchedule:
					"Notifica a la clínica inmediatamente cuando empiece tu período (Día 1); Rastrea el pico de LH a diario desde el DC10 si el ciclo es natural; Asiste a la ecografía de monitoreo en DC10–12 si es medicado",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"El timing es el elemento más crítico de la IIU. Es común sentir ansiedad por hacerlo bien — la clínica te dará instrucciones claras sobre cuándo testear, desencadenar y acudir.",
				milestone: "Pico de LH o inyección desencadenante, est. 2 may",
				currentDayLabel: "Día [N] de ~12",
				estimatedLengthDays: 12,
				monitoringFrequency: "cada 2–3 días",
				nextEvent: "completado",
			},
			tasks: [
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss1-task1",
					title: "Notificar: Período comenzó — Día 1",
					description: "Registra el día 1 para iniciar tu protocolo",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-01",
					subStepTitle: "Inicio del ciclo y línea base",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss1-task2",
					title: "Reservar: Ecografía basal — Día 2–3",
					description: "Confirma que los ovarios están listos",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-01",
					subStepTitle: "Inicio del ciclo y línea base",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss1-task3",
					title: "Análisis: Ecografía basal",
					description: "Verificación de ovarios y endometrio antes del ciclo",
					category: "clinical",
					deadline: "Día 2 o 3 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-01",
					subStepTitle: "Inicio del ciclo y línea base",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss2-task1",
					title: "Monitorear: Síntomas del ciclo",
					description:
						"Registra signos del pico de LH, mucosidad y cólicos a diario",
					category: "cycle",
					deadline: "Días 10–16 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-02",
					subStepTitle: "Seguimiento de la ovulación",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss2-task2",
					title: "Análisis: Test de ovulación casero",
					description: "Rastrea tu pico de LH — solo ciclo natural",
					category: "cycle",
					deadline: "Días 10–16 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-02",
					subStepTitle: "Seguimiento de la ovulación",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss2-task3",
					title: "Reservar: Ecografía de monitoreo — Día 10–12",
					description:
						"Verificación del crecimiento folicular — ciclo medicado",
					category: "clinical",
					deadline: "Antes del día 9 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-02",
					subStepTitle: "Seguimiento de la ovulación",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss2-task4",
					title: "Análisis: Visita de monitoreo — Ecografía y sangre",
					description: "Tamaño folicular y niveles de LH/E2",
					category: "clinical",
					deadline: "Día 10–12 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-02",
					subStepTitle: "Seguimiento de la ovulación",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss2-task5",
					title: "Monitorear: Niveles hormonales",
					description: "Rastrea las tendencias de E2 y LH entre visitas",
					category: "clinical",
					deadline: "Días 10–14 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-02",
					subStepTitle: "Seguimiento de la ovulación",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-ss3-task1",
					title: "Notificar: Inyección desencadenante administrada",
					description: "Confirma que tu inyección de hCG fue a tiempo",
					category: "medication",
					deadline: "La misma noche de la inyección",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "iui-step-4-cycle-monitoring-ovulation-tracking-ss-03",
					subStepTitle: "Inyección desencadenante (si es medicado)",
				},
			],
			faqs: [
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-faq-1",
					question: "¿Cómo sé cuándo hacer la IIU?",
					answer:
						"En un ciclo natural, una prueba casera de LH detecta el pico hormonal que indica que se acerca la ovulación — la IIU se realiza típicamente 24–36 horas después de detectar el pico. En un ciclo medicado, se administra una inyección desencadenante cuando el folículo dominante alcanza el tamaño correcto en la ecografía, y la IIU se programa aproximadamente 36 horas después. La clínica te dará instrucciones específicas según el protocolo.",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-faq-2",
					question: "¿Qué implica una ecografía de monitoreo?",
					answer:
						"Una ecografía de monitoreo es una ecografía transvaginal que verifica el tamaño y número de folículos en desarrollo y el grosor del endometrio. Toma unos 15–20 minutos en la clínica. Para ciclos medicados, son típicas 1–3 ecografías de monitoreo a lo largo del ciclo. Los resultados determinan si la dosis de medicación necesita ajustarse y confirman el momento adecuado para la inyección desencadenante y la inseminación.",
				},
				{
					id: "iui-step-4-cycle-monitoring-ovulation-tracking-faq-3",
					question: "¿Se puede cancelar el ciclo de IIU?",
					answer:
						"Sí — los ciclos a veces se cancelan si los ovarios no responden a la medicación como se esperaba, si se desarrollan demasiados folículos, o si el pico de LH ocurre antes o después de lo anticipado. Aunque un ciclo cancelado es decepcionante, proporciona información útil que ayuda al equipo a ajustar el enfoque para el siguiente intento. La cancelación es una decisión preventiva, no una señal de que el tratamiento no funcionará.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Monitoreo del ciclo y ovulación.",
		},
		{
			id: "iui-step-5-insemination-day",
			order: 5,
			title: "Día de inseminación",
			description:
				"Este es el día del procedimiento. El esperma preparado se coloca directamente en el útero a través de un catéter delgado — un procedimiento rápido y de baja molestia que normalmente toma menos de 15 minutos.",
			estimatedDateRange:
				"Est. 3 may 2026 [~36 hrs después del pico de LH o inyección desencadenante]",
			estimatedStartDate: "2026-05-03",
			status: "current",
			subSteps: [
				{
					id: "iui-step-5-insemination-day-ss-01",
					title: "Preparación previa al procedimiento",
				},
				{
					id: "iui-step-5-insemination-day-ss-02",
					title: "Preparación del esperma y procedimiento",
				},
				{
					id: "iui-step-5-insemination-day-ss-03",
					title: "Monitoreo posterior al procedimiento",
				},
			],
			highlight: {
				dayCount: "1 días",
				monitoringSchedule:
					"Completa la lista previa al procedimiento el día anterior; Organiza descansar suavemente después del procedimiento",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"El día de la IIU puede sentirse a la vez trascendente y anticlimático — el procedimiento en sí es breve. Muchas personas se sienten emocionadas, aliviadas, o ambas cosas. Eso es completamente normal.",
				milestone: "Procedimiento IIU completado, est. 3 may",
				currentDayLabel: "Día 1 de 1",
				estimatedLengthDays: 1,
				monitoringFrequency: "1 visita",
				nextEvent: "hoy, procedimiento IIU 10:00",
			},
			tasks: [
				{
					id: "iui-step-5-insemination-day-ss1-task1",
					title: "Completar: Lista previa al procedimiento",
					description: "Hora de llegada e instrucciones confirmadas",
					category: "clinical",
					deadline: "Día antes de la IIU",
					status: "ongoing",
					progress: 60,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-5-insemination-day-ss-01",
					subStepTitle: "Preparación previa al procedimiento",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "iui-step-5-insemination-day-ss1-task2",
					title: "Reservar: Procedimiento IIU",
					description: "Programa tu cita de inseminación en la clínica",
					category: "clinical",
					deadline: "~36 horas después de la inyección o pico de LH",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-5-insemination-day-ss-01",
					subStepTitle: "Preparación previa al procedimiento",
				},
				{
					id: "iui-step-5-insemination-day-ss2-task1",
					title: "Análisis: Preparación del esperma en laboratorio",
					description:
						"El laboratorio lava y prepara el esperma antes de la inseminación",
					category: "clinical",
					deadline: "Día del procedimiento IIU",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-5-insemination-day-ss-02",
					subStepTitle: "Preparación del esperma y procedimiento",
				},
				{
					id: "iui-step-5-insemination-day-ss2-task2",
					title: "Análisis: Procedimiento IIU",
					description:
						"Colocación del catéter y depósito del esperma en el útero",
					category: "clinical",
					deadline: "Día del procedimiento IIU",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-5-insemination-day-ss-02",
					subStepTitle: "Preparación del esperma y procedimiento",
				},
				{
					id: "iui-step-5-insemination-day-ss3-task1",
					title: "Monitorear: Síntomas post-IIU",
					description:
						"Registra cólicos leves y manchado tras el procedimiento",
					category: "clinical",
					deadline: "24–48 horas post-IIU",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "iui-step-5-insemination-day-ss-03",
					subStepTitle: "Monitoreo posterior al procedimiento",
				},
				{
					id: "iui-step-5-insemination-day-ss3-task2",
					title: "Revisar y firmar: Protocolo de soporte de progesterona",
					description:
						"Instrucciones de soporte de fase lútea si está prescrito",
					category: "medication",
					deadline: "Día del procedimiento IIU",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "iui-step-5-insemination-day-ss-03",
					subStepTitle: "Monitoreo posterior al procedimiento",
				},
			],
			faqs: [
				{
					id: "iui-step-5-insemination-day-faq-1",
					question: "¿Qué sucede el día del procedimiento de IIU?",
					answer:
						"La muestra de esperma se recolecta y se procesa en el laboratorio — concentrando el esperma móvil y eliminando el fluido seminal. La muestra preparada se introduce en un catéter delgado que se pasa suavemente a través del cuello uterino al útero. Se deposita el esperma y se retira el catéter. El proceso toma unos 10–15 minutos. Es común tener cólicos leves inmediatamente después. La mayoría de personas pueden continuar su día con normalidad.",
				},
				{
					id: "iui-step-5-insemination-day-faq-2",
					question: "¿Duele la IIU?",
					answer:
						"La mayoría describe la IIU como ligeramente incómoda más que dolorosa — similar a una citología o un cólico menstrual leve. El paso del catéter por el cuello uterino puede causar un breve pinchazo o cólico. Tomar un analgésico sin receta 30–60 minutos antes de la cita, si la clínica lo recomienda, puede ayudar a reducir las molestias.",
				},
				{
					id: "iui-step-5-insemination-day-faq-3",
					question: "¿Qué debo hacer después del procedimiento?",
					answer:
						"No hay evidencia de que acostarse después de la IIU mejore los resultados. Es adecuado realizar actividad suave y normal el resto del día. El ejercicio intenso y la natación generalmente se evitan durante 24–48 horas. Todos los medicamentos deben continuarse según lo prescrito. Cualquier soporte de progesterona prescrito debe comenzarse el día indicado por la clínica.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Día de inseminación.",
		},
		{
			id: "iui-step-6-two-week-wait",
			order: 6,
			title: "Espera de dos semanas",
			description:
				"Este paso es el período de espera entre la inseminación y el análisis de embarazo. Continúa con cualquier medicación, registra síntomas y accede al apoyo cuando lo necesites.",
			estimatedDateRange: "Est. 3 may – 17 may 2026 [Día 1–14 post-IIU]",
			estimatedStartDate: "2026-05-03",
			status: "future",
			subSteps: [
				{
					id: "iui-step-6-two-week-wait-ss-01",
					title: "Soporte de progesterona (si está prescrito)",
				},
				{
					id: "iui-step-6-two-week-wait-ss-02",
					title: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "iui-step-6-two-week-wait-ss-03",
					title: "Apoyo emocional",
				},
				{
					id: "iui-step-6-two-week-wait-ss-04",
					title: "Reserva del análisis Beta hCG",
				},
			],
			highlight: {
				dayCount: "14 días",
				monitoringSchedule:
					"Continúa con el soporte de progesterona si está prescrito — no lo suspendas; Registra síntomas a diario en la app; Reserva el análisis Beta hCG a los 14 días post-IIU",
				staffInfo: "Enfermera B. Chen",
				headsUpNote:
					"La espera de dos semanas tras la IIU lleva la misma intensidad emocional que tras la FIV. Los síntomas no pueden predecir el resultado. Es común que este período resulte genuinamente difícil.",
				milestone: "Análisis Beta hCG, est. 17 may",
				currentDayLabel: "Día [N] de ~14",
				estimatedLengthDays: 14,
				monitoringFrequency: "registro diario",
				nextEvent: "17 may, análisis Beta hCG",
			},
			tasks: [
				{
					id: "iui-step-6-two-week-wait-ss1-task1",
					title: "Monitorear: Efectos de la medicación",
					description:
						"Registra tu respuesta diaria al soporte de progesterona",
					category: "medication",
					deadline: "A diario durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "iui-step-6-two-week-wait-ss-01",
					subStepTitle: "Soporte de progesterona (si está prescrito)",
				},
				{
					id: "iui-step-6-two-week-wait-ss2-task1",
					title: "Monitorear: Síntomas de la espera",
					description:
						"Rastrea cólicos, manchado y signos tempranos de embarazo",
					category: "clinical",
					deadline: "A diario durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "iui-step-6-two-week-wait-ss-02",
					subStepTitle: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "iui-step-6-two-week-wait-ss2-task2",
					title: "Monitorear: Bienestar y ánimo",
					description:
						"Chequeo emocional diario durante la espera de dos semanas",
					category: "cycle",
					deadline: "A diario durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "iui-step-6-two-week-wait-ss-02",
					subStepTitle: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "iui-step-6-two-week-wait-ss2-task3",
					title: "Notificar: Síntoma nuevo o efecto secundario",
					description: "Reporta sangrado abundante o dolor severo de inmediato",
					category: "clinical",
					deadline: "En cuanto ocurra",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "notify",
					subStepId: "iui-step-6-two-week-wait-ss-02",
					subStepTitle: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "iui-step-6-two-week-wait-ss3-task1",
					title: "Reservar: Sesión de apoyo emocional",
					description: "Habla con una psicóloga de tu equipo de cuidado",
					category: "cycle",
					deadline: "En cualquier momento durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-6-two-week-wait-ss-03",
					subStepTitle: "Apoyo emocional",
				},
				{
					id: "iui-step-6-two-week-wait-ss4-task1",
					title: "Reservar: Análisis de embarazo — Beta hCG",
					description: "Confirma el embarazo tras tu inseminación",
					category: "clinical",
					deadline: "14 días post-IIU",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-6-two-week-wait-ss-04",
					subStepTitle: "Reserva del análisis Beta hCG",
				},
			],
			faqs: [
				{
					id: "iui-step-6-two-week-wait-faq-1",
					question:
						"¿Puedo hacer un test casero de embarazo durante la espera?",
					answer:
						"Si se usó una inyección desencadenante, los tests caseros pueden dar falso positivo durante varios días mientras la hCG se elimina del sistema. Incluso sin desencadenante, hacer la prueba temprano a menudo da resultados poco concluyentes o engañosos ya que la implantación tarda varios días tras la inseminación. El análisis clínico de sangre del día 14 es más preciso y da un nivel cuantitativo de hCG en lugar de solo sí o no.",
				},
				{
					id: "iui-step-6-two-week-wait-faq-2",
					question: "¿Qué síntomas son comunes después de la IIU?",
					answer:
						"Los cólicos leves y manchado en las primeras 24–48 horas son comunes después del procedimiento mismo. Después, cualquier síntoma experimentado se debe en gran parte a la medicación de soporte de progesterona si está prescrita, no a si ha ocurrido implantación. La sensibilidad mamaria, hinchazón y fatiga pueden aparecer independientemente del resultado. Sangrado abundante, fiebre o dolor severo deben reportarse rápidamente a la clínica.",
				},
				{
					id: "iui-step-6-two-week-wait-faq-3",
					question: "¿Cómo se gestiona la carga emocional de la espera?",
					answer:
						"Mantenerse suavemente ocupada, mantener rutinas normales cuando sea posible, y tener a alguien con quien hablar son estrategias que ayudan a muchas personas. La sesión de apoyo emocional incluida en este paso está disponible sin necesidad de un motivo específico. Limitar el tiempo en foros en línea, donde los resultados no son representativos de la experiencia típica, también es algo que muchas encuentran genuinamente útil.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Espera de dos semanas.",
		},
		{
			id: "iui-step-7-pregnancy-test-next-steps",
			order: 7,
			title: "Prueba de embarazo y próximos pasos",
			description:
				"Hoy es el día del análisis de embarazo. Sea cual sea el resultado, tu equipo de cuidado está aquí — para celebrar y planificar próximos pasos, o para revisar y mirar adelante juntos.",
			estimatedDateRange: "Est. 17 may 2026 [Día 14 post-IIU]",
			estimatedStartDate: "2026-05-17",
			status: "future",
			subSteps: [
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss-01",
					title: "Análisis de sangre Beta hCG",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss-02",
					title: "Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss-03",
					title: "Resultado negativo — revisión del ciclo",
				},
			],
			highlight: {
				dayCount: "1–3 días",
				monitoringSchedule:
					"Asiste al análisis de sangre Beta hCG en la fecha programada — no hagas la prueba antes; Sube el resultado y notifica a la clínica el mismo día",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Hoy trae un resultado significativo — y emociones significativas en cualquier sentido. Tener a alguien disponible, sea cual sea el resultado, es algo que muchas personas encuentran importante.",
				milestone: "Resultado Beta hCG, est. 17 may",
				currentDayLabel: "Día [N] de ~3",
				estimatedLengthDays: 3,
				monitoringFrequency: "1–2 visitas",
				nextEvent: "17 may, resultado Beta hCG",
			},
			tasks: [
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss1-task1",
					title: "Análisis: Análisis de embarazo — Beta hCG",
					description: "Confirma el embarazo tras tu inseminación",
					category: "clinical",
					deadline: "14 días post-IIU",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-01",
					subStepTitle: "Análisis de sangre Beta hCG",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss1-task2",
					title: "Subir: Resultado de Beta hCG",
					description: "El resultado activa la vía positiva o negativa",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "upload",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-01",
					subStepTitle: "Análisis de sangre Beta hCG",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss1-task3",
					title: "Notificar: Resultados recibidos",
					description:
						"Informa a tu equipo que tus resultados de Beta hCG están listos",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "notify",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-01",
					subStepTitle: "Análisis de sangre Beta hCG",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss2-task1",
					title: "Reservar: Ecografía de confirmación",
					description: "Confirmación del latido si la Beta hCG es positiva",
					category: "clinical",
					deadline: "~6–7 semanas de gestación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-02",
					subStepTitle:
						"Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss2-task2",
					title: "Análisis: Ecografía de confirmación",
					description: "Confirma el saco gestacional, polo fetal y latido",
					category: "clinical",
					deadline: "~6–7 semanas de gestación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-02",
					subStepTitle:
						"Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss2-task3",
					title: "Reservar: Cita de derivación a obstetra",
					description: "Transferencia de la clínica de fertilidad al obstetra",
					category: "clinical",
					deadline: "~8–10 semanas de gestación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-02",
					subStepTitle:
						"Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss3-task1",
					title: "Completar: Formulario de revisión del ciclo",
					description:
						"Documenta los resultados de tu ciclo para revisión clínica",
					category: "clinical",
					deadline: "Dentro de 1 semana del resultado",
					status: "ongoing",
					progress: 60,
					source: "clinic",
					iconName: "fill",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-03",
					subStepTitle: "Resultado negativo — revisión del ciclo",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-ss3-task2",
					title: "Reservar: Consulta de revisión del ciclo",
					description:
						"Discute tus resultados y próximos pasos con tu especialista",
					category: "clinical",
					deadline: "Dentro de 2 semanas del resultado",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "iui-step-7-pregnancy-test-next-steps-ss-03",
					subStepTitle: "Resultado negativo — revisión del ciclo",
				},
			],
			faqs: [
				{
					id: "iui-step-7-pregnancy-test-next-steps-faq-1",
					question: "¿Qué significa el nivel de Beta hCG después de la IIU?",
					answer:
						"La Beta hCG es la hormona producida después de que un óvulo fertilizado se implanta. Un nivel superior a 25 mUI/mL generalmente se considera positivo, aunque los umbrales varían entre clínicas. Tras la IIU, un solo resultado es menos informativo que la tendencia — la clínica puede solicitar un análisis repetido a las 48 horas para confirmar que el nivel sube adecuadamente. Un nivel ascendente indica un embarazo en desarrollo; un nivel descendente tras un positivo inicial puede indicar un embarazo bioquímico.",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-faq-2",
					question: "¿Qué pasa si el resultado es negativo?",
					answer:
						"Un resultado negativo tras la IIU es difícil, y es válido necesitar tiempo antes de pensar en próximos pasos. Tu equipo de cuidado programará una revisión del ciclo — generalmente dentro de 1–2 semanas — para discutir lo aprendido, si se justifican cambios de protocolo, y si se recomienda otro ciclo de IIU o un enfoque diferente.",
				},
				{
					id: "iui-step-7-pregnancy-test-next-steps-faq-3",
					question: "¿Qué pasa después de un resultado positivo?",
					answer:
						"Tras una Beta hCG positiva, un análisis repetido 48 horas después confirma que el nivel sube, seguido de una ecografía de confirmación a las 6–7 semanas para verificar el saco gestacional, polo fetal y latido. Si se confirma, el cuidado se transfiere a un obstetra alrededor de las 8–10 semanas. La clínica de fertilidad indicará cuándo reducir y suspender el soporte de progesterona, que generalmente se reduce gradualmente una vez confirmado clínicamente el embarazo.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Prueba de embarazo y próximos pasos.",
		},
	],
};
